<template lang="pug">
Card.selections-card
  template(#header)
    .title {{ $t('selections.storeys.title') }}
  template(#content)
    .storeys-control
      SelectionsButtons.selector(:items="items" v-model="storeys" @select="updateStoreys")

</template>
<script lang="ts">
import { useSelections } from "@/store/selections";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import Card from "primevue/card";
import { useSettings } from "@/store";
import SelectionsButtons from "@/components/forms/components/SelectionsButtons.vue";
import { computed } from "vue";

export default defineComponent({
  name: "NumberOfStoreys",
  components: {
    Card,
    SelectionsButtons,
  },
  setup() {
    const selections = useSelections();
    const { storeys, storeysAvailable } = storeToRefs(selections);
    const { resetTypeAndTypology } = selections;
    const { settings } = storeToRefs(useSettings());

    const items = computed(() => [
      { label: "1", value: 1, disabled: !storeysAvailable.value.one },
      { label: "2+", value: 2, disabled: !storeysAvailable.value.twoPlus },
    ]);

    function updateStoreys(item: number) {
      if (item != storeys.value) {
        resetTypeAndTypology();
      }
    }

    return {
      storeys,
      updateStoreys,
      settings,
      items,
    };
  },
});
</script>
<style scoped lang="scss">
.selector {
  &:deep(.form-control-radio-buttons) {
    padding: 2rem 0;
    width: 350px;
    display: flex;
    justify-content: space-between;
  }

  &:deep(.radio-content) {
    display: flex;
    align-items: center;

    label {
      margin-left: 1rem;
      font-size: 1.1rem;
    }

    &:nth-child(2) {
      justify-content: flex-end;
    }
  }
}

@media screen and (max-width: 1120px) {
  .storeys-wrapper {
    padding: 0.75rem 0;
    width: 100%;

    .storey {
      width: 50%;
    }
  }
}
</style>
